// Čas OBCHODU, ne prohlížeče. Akce končí, když ji ukončí e-shop, takže zákazník
// v jiném pásmu musí vidět tentýž zbývající čas jako my — jinak by mu neděle
// „končila" o hodiny dřív nebo později.
//
// Sdílí zóna SLEVOAKCE na homepage (týdenní odpočet, pevný konec kampaně)
// a okna akcí (`shippingModel.shippingPromo`, kampaně). Vytaženo z homepage.js
// 2026-10-06 (#322); homepage.js funkce dál re-exportuje, importují je harnessy.
// Pásmo je manifest shopu (`shop.timeZone`), modul jde importovat i v Node.
import SHOP from '../../config/shop.js';

const SHOP_TZ = SHOP.shop.timeZone;

// Formatter se staví jednou: konstrukce `Intl.DateTimeFormat` je drahá a `shopParts`
// volá každá karta výpisu (termín expedice), na homepage to bylo 104 ms bootu při
// CPU 4× (profil 2026-10-13, ops/sweeps/2026-10-13-lcp-kostra/boot-profile.mjs).
let fmt;

// Části data v pásmu obchodu. `hour12:false` vrací v části enginů o půlnoci „24"
// místo „0" — proto %24.
export function shopParts(ms) {
  const p = {};
  if (!fmt) {
    fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: SHOP_TZ,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }
  fmt
    .formatToParts(new Date(ms))
    .forEach(function (part) {
      p[part.type] = part.value;
    });
  return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second };
}

// Posun pásma obchodu proti UTC v daném okamžiku (+1 h v zimě, +2 h v létě).
function shopOffset(ms) {
  const p = shopParts(ms);
  return Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - Math.floor(ms / 1000) * 1000;
}

// Půlnoc daného kalendářního dne v pásmu obchodu → epoch. Dvě iterace stačí:
// posun se mění nejvýš o hodinu a půlnoc nikdy neleží v okně přechodu na letní
// čas (Praha přepíná ve 02:00/03:00), takže druhý průchod je už přesný.
export function shopMidnight(y, m, d) {
  const naive = Date.UTC(y, m - 1, d);
  return naive - shopOffset(naive - shopOffset(naive));
}

// Nejbližší nedělní půlnoc (= pondělí 00:00) v pásmu obchodu, vždy v budoucnu.
export function nextSundayMidnight(now) {
  try {
    const p = shopParts(now);
    // getUTCDay nad holým kalendářním dnem: 0 = neděle … 6 = sobota.
    const dow = new Date(Date.UTC(p.y, p.m - 1, p.d)).getUTCDay();
    // Do pondělí: v neděli 1 den, jinak zbytek týdne. V pondělí je to celých 7 —
    // dnešní 00:00 už je za námi, cílem je konec nadcházející neděle.
    return shopMidnight(p.y, p.m, p.d + (dow === 0 ? 1 : 8 - dow));
  } catch (e) {
    // Bez Intl padáme na lokální čas prohlížeče. O hodinu vedle je pořád lepší
    // než odpočet, který se kvůli výjimce nevykreslí vůbec.
    const t = new Date(now);
    const dow = t.getDay();
    return new Date(t.getFullYear(), t.getMonth(), t.getDate() + (dow === 0 ? 1 : 8 - dow)).getTime();
  }
}

// Okamžik zapsaný v čase OBCHODU („2026-08-31T23:59", „2026-10-25T23:59:59",
// jen datum = půlnoc). `Date.parse` by tvar bez offsetu bral v pásmu prohlížeče
// a kampaň by každému končila jindy (review B4-04). Hodnota s explicitním
// offsetem nebo `Z` jde beze změny přes Date.parse; nesmysl = NaN.
export function parseShopEnd(raw) {
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(String(raw || '').trim());
  if (!m) return Date.parse(raw);
  const naive = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
  try {
    return naive - shopOffset(naive - shopOffset(naive));
  } catch (e) {
    return Date.parse(raw);
  }
}

/**
 * Leží `now` v okně akce `[from, until]` (oba konce včetně, čas obchodu)?
 * Nečitelná hranice = okno neplatí (akce se radši neukáže, než aby lhala).
 *
 * @param {string} from  začátek v čase obchodu („2026-10-12T00:00")
 * @param {string} until konec v čase obchodu („2026-10-25T23:59:59")
 * @param {number} [now] epoch ms, výchozí Date.now()
 */
export function inShopWindow(from, until, now) {
  const t = now == null ? Date.now() : now;
  const a = parseShopEnd(from);
  const b = parseShopEnd(until);
  if (isNaN(a) || isNaN(b)) return false;
  return t >= a && t <= b;
}
